import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { BsArrowsFullscreen } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { adminLogin, loadeUser } from "../../action/adminAction";
import "./login.css";
import instance from "../../Components/Apis/axios";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [users, setUser] = useState({});
  const [checked, setChecked] = useState(false);
  const { user, loading } = useSelector((state) => state.user);

  const changeHandler = (e) => {
    setUser({ ...users, [e.target.name]: e.target.value });
  };

  const setCookie = (name, value, options) => {
    document.cookie = `${name}=${value}; expires=${options.expires}; path=${options.path}`;
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    const { email, password } = users;
    const { data } = await instance.post("admin/login", { email, password });

    if (data.success == false) {
      toast(data.message);
    } else {
      dispatch(loadeUser());
    }
  };

  useEffect(() => {
    if (!loading) {
      {
        !user ? navigate("/dashboard") : navigate("/");
      }
    }
  }, [user]);

  return (
    <>
      <div className="loginContainer">
        <div className="box-form">
          <div className="left">
            <img src="/assests/Login_Page.png" alt="" />
          </div>
          <form className="right" onSubmit={submitHandler}>
            <h5>Login</h5>
            <div className="inputs">
              <div className="input">
                <input
                  name="email"
                  type="email"
                  value={users.email}
                  onChange={changeHandler}
                  placeholder="users Email"
                  required
                />
                <i className="fa-solid fa-users"></i>
              </div>
              <br />
              <div className="input">
                <input
                  type="password"
                  name="password"
                  value={users.password}
                  onChange={changeHandler}
                  placeholder="password"
                  required
                />
                <i className="fa-solid fa-lock"></i>
              </div>
            </div>

            {/* <div className="remember-me--forget-password">
              <label>
                <input
                  type="checkbox"
                  name="lsRememberMe"
                  checked={checked}
                  onChange={(e) => setChecked(e.target.checked)}
                />
                <span className="text-checkbox">Remember me</span>
              </label>
            
            </div> */}
            <br />
            <div className="social_icon">
              <input id="sumitIcon" type="Submit" value={"Login"} />
              <span>
                <Link to="#">
                  <i className="fa fa-google" aria-hidden="true"></i>
                </Link>
                {/* <Link to="#"><i className="fa fa-facebook" aria-hidden="true"></i></Link> */}
              </span>
            </div>
            <ToastContainer />
          </form>
        </div>
      </div>
    </>
  );
};

export default Login;
